import { render } from "./PostIdPage.vue?vue&type=template&id=18fad8d0"
import script from "./PostIdPage.vue?vue&type=script&lang=js"
export * from "./PostIdPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\secret\\py\\main_bot\\bank-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__